export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14527.0b344b3e.jpg";